import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import logo from '../images/logo_clock.png'
import CopyToClipboard from 'react-copy-to-clipboard';
import { MdCopyAll, MdShare } from 'react-icons/md';
import QRCode from 'react-qr-code';
import { useDispatch, useSelector } from 'react-redux';
import { getBusinessProfile } from '../logic/business/action';
import { RWebShare } from 'react-web-share';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SERVER_DOMAIN } from '../utils/secret';
import myCorr from "../images/tick.png"
import { successMessage } from "../logic/error/action";

const QrCodeScreen = () => {
  const selector = useSelector((state) => state.business);
const selectorAuth = useSelector((state) => state.auth);
// const MyIcon = () => (
//   <img src={myCorr} alt='toast'/>
// );
// const handleCopyToClipboard = () => {
//   toast.success('Url copied', {
//     icon: <MyIcon/>,
//     position: 'bottom-right',
//     autoClose: 3000,
//     hideProgressBar: true,
//   });
// }

const dispatch = useDispatch();
useEffect(() => {
  getBusinessProfile(dispatch);
}, []);

return (
  <div className='bg-gray-200 w-screen h-auto lg:h-screen pb-10 flex flex-col items-center'>
  <header className='w-full lg:w-[80%] mx-auto flex items-center py-4 justify-between px-4'>
      <img src={logo} className='w-20 h-20'></img>
      <div className='flex items-center gap-4'>
      <p className='hidden lg:inline-block'>(team@theappointmentapp.com.com)</p>
    <Link to={'/admin'}>
    <p className='px-10 py-1 rounded border border-gray-400'>Dashboard</p>
    </Link>
      </div>
    </header>
    <div className='w-full lg:w-[70%] flex flex-col gap-4 items-center bg-white p-10 rounded-md'>
            <h2 className='font-bold text-2xl'>{selector?.details?.name}'s QR Code</h2>
            {/* <h2 className="font-bold text-2xl">QR Code</h2> */}
      <div className="w-full flex items-center flex-wrap-reverse gap-10">
        <div className="flex-1 min-w-full lg:min-w-[45%]">
          <h2 className="font-medium text-xl w-full text-center">
            Share your QR code <br /> for booking an Appointment
          </h2>
          <div className="flex items-center justify-center gap-10">
            
          </div>

          <div className="w-full flex items-center gap-2 my-2">
            <span className="flex-1 h-[1px] bg-gray-400"></span>
            <p>OR</p>
            <span className="flex-1 h-[1px] bg-gray-400"></span>
          </div>
          <div className="w-full flex items-center gap-4 justify-center">
            <div className="w-fit max-w-[70%] p-4 bg-gray-50 rounded-md">
              <a
                className="text-ellipsis w-full overflow-hidden whitespace-nowrap block"
                href={`https://taa.dukaani.in/business/${selector?.details?.name
                  ?.trim()
                  .replaceAll(" ", "_")}/${
                  selector?.details?.business_id
                }/book-appointment`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`https://taa.dukaani.in/business/${selector?.details?.name
                ?.trim()
                .replaceAll(" ", "_")}/${
                selector?.details?.business_id
              }/book-appointment`}</a>
            </div>
            <RWebShare
              data={{
                text: "Hello, Click this link for booking Appointment.",
                url: `https://taa.dukaani.in/business/${selector?.details?.name
                  ?.trim()
                  .replaceAll(" ", "_")}/${
                  selector?.details?.business_id
                }/book-appointment`,
                title: "Share link",
              }}
              disableNative={false}
              onClick={() => console.log("shared successfully!")}
            >
              <MdShare/>
              {/* <button>Share Link</button> */}
            </RWebShare>
            <CopyToClipboard
              onCopy={() => 
                successMessage(dispatch,'URL Copied')
                }
              text={`https://taa.dukaani.in/business/${selector?.details?.name
                ?.trim()
                .replaceAll(" ", "_")}/${
                selector?.details?.business_id
              }/book-appointment`}
            >
              <MdCopyAll className="text-2xl cursor-pointer"/>
            </CopyToClipboard>
          </div>
        </div>
        <div className="w-fit bg-primary rounded-lg p-10 flex items-center flex-col gap-4">
          <div className="w-fit rounded-md p-2 mx-auto bg-white">
            {/* <p>{selector?.details?.business_name?.replace('\d','_')}</p> */}
            <QRCode
              size={200}
              value={`https://taa.dukaani.in/business/${selector?.details?.name
                ?.trim()
                .replaceAll(" ", "_")}/${
                selector?.details?.business_id
              }/book-appointment`}
            />
          </div>
        </div>
      </div>
      </div>
  </div>
)
}


export default QrCodeScreen;